import { Box, Container, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

import Page from "../elements/Page";

const Privacy = () => {
  return (
    <>
      <Page title="개인정보처리방침 :: Click">
        <Container sx={{ pb: 5 }}>
          <Box sx={{ my: 5 }} display="flex">
            <Typography variant="h4">클릭리스 개인정보처리방침</Typography>
          </Box>

          <ReactMarkdown remarkPlugins={[remarkBreaks, remarkGfm]}>{`
[ 클릭리스 개인정보처리방침 ]


클릭리스 개인정보처리방침은 회사가 제공하는 다양한 서비스를 제공함에 있어, 정보를 어떻게 수집·이용·보관·파기하는지에 대한 정보를 담은 방침을 의미합니다. 클릭리스 개인정보처리방침은 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 국내의 개인정보 보호 법령을 준수하고 있습니다. 본 방침은 회사가 제공하는 클릭리스 및 클릭리스 관련 제반 서비스 이용에 적용됩니다.



1. 수집하는 개인정보의 항목
회사는 서비스 제공을 위해 아래 항목 중 최소한의 개인정보를 수집합니다.


1) 회원이 회원가입 또는 본인확인을 할 경우
- 이메일주소, 소속(연계병원), SNS 아이디, 개인 정보 수신 동의여부

2) 회원이 서비스를 이용하는 경우
- IP Address, 방문일시, 서비스 이용기록

3) 회원이 병원 연동 코드 인증을 할 경우
- 이메일 주소, 이름, 코드

4) 광고성 정보 전송
- 이메일 주소

※ 각 항목 또는 추가적으로 수집이 필요한 항목의 개인정보는 회원이 문의하기 기능이나 다른 방식으로 회사에 문의하거나, 회사가 회원에게 문의하는 과정에서 수집될 수 있습니다.

※ 서비스 이용 과정에서 기기정보, 이용기록, 로그 기록 등이 자동으로 수집될 수 있습니다.
※ 회사는 인종, 사상, 의료정보 등 회원의 민감정보를 절대로 수집하지 않습니다.



2. 수집한 개인정보의 목적
회사는 쾌적한 서비스를 제공하기 위해, 아래의 목적에 한해 개인정보를 이용합니다.

1) 회원 및 개인 식별, 가입의사 및 탈퇴의사 확인, 클릭리스 이용약관 위반 회원에 대한 이용제한 조치, 부정이용 및 중복가입 방지, 탈퇴자에 대한 재가입 제한, 병원 연동 코드 확인 등 회원관리

2) 분쟁 조정을 위한 기록보존

3) 불만 및 민원 처리, 공지사항 전달

4) 보안, 프라이버시, 안전 측면에서 이용자가 안심하고 이용할 수 있는 서비스 이용환경 구축

5) 의학 정보 및 커뮤니티 활용을 위한 서비스 개발·제공·개선

6) 회원 문의/제안/제휴/협력/게시 요청 처리

7) 회사가 회원 간 체결한 약관 이행

8) 프로모션 정보 전송 및 응대 (뉴스레터 발송, 서비스 및 콘텐츠 소개, 광고성 정보 안내)

3. 개인정보의 제3자 제공 및 처리위탁
회사는 관련법 및 회원의 동의가 없는 한, 회원의 개인정보를 제3자에게 절대 제공하지 않습니다. 단, 회사는 보안성 높은 서비스 제공을 위하여 신뢰도가 검증된 아래 회사에게 개인정보 관련 업무 처리를 위탁할 수 있습니다. 이 경우 회사는 회원들에게 위탁을 받는 자와 업무의 내용을 사전에 알리고 동의를 받습니다. 위탁을 받는 자 또는 업무의 내용이 변경될 경우에도 같습니다.
회사는 정보통신서비스의 제공에 관한 계약을 이행하고 회원의 편의 증진 등을 위하여 추가적인 처리 위탁이 필요한 경우에는 고지 및 동의 절차를 거치지 않을 수 있습니다.
- Amazon Web Service: 서비스 시스템 제공, 데이터 관리 및 보관




4. 수집한 개인정보의 보관 및 파기
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.

1) 회원식별정보(이메일, 연동코드)
- 이 유 : 재가입 및 중복 가입 예방
- 보존 기간 : 1년

2) 부정이용기록(약관 위반 등의 비정상적 서비스 이용기록, 해당자의 이름, 이메일)
- 이 유 : 부정 이용방지
- 보존 기간 : 5년

3) 이벤트 참여 및 당첨 정보 : 1년

단, 법령에 의해 항목을 보관할 경우, 해당 법령에서 정한 최대 기간만큼 저장합니다. 파기된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.

※ 회원이 1년 이상 로그인 및 접속을 하지 않을 경우, 해당 계정은 개인정보의 안전한 처리를 위해 분리 보관되며, 이외의 개인정보 및 이용기록은 모두 파기될 수 있습니다. 분리 보관된 이후에도 3년 간 로그인을 하지 않을 경우 해당 계정은 영구 삭제될 수 있습니다.


5. 이용자 및 법정대리인의 권리와 그 행사방법
회사는 이용자들이 이용약관과 개인정보 수집 및 이용동의버튼을 클릭할 수 있는 절차를 마련하여, 개인정보 수집 및 이용동의 버튼을 클릭하면 개인정보 수집 및 이용에 대해 동의한 것으로 봅니다.
이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 약관에 명시된 절차에 의거해 이용 계약해지(탈퇴)를 요청하실 수 있습니다. 다만, 이러한 경우 서비스 이용이 어려울 수 있습니다.
본인 또는 법정대리인이 개인정보 삭제를 원하는 경우 아래 고객센터를 이용해 연락을 취하시면 신속히 조치해드리겠습니다.

- 본사 홈페이지 : beyondmedicine.kr
- 전화:　070-8095-5096(보다 원활한 소통을 위해선 위 카카오톡으로 부탁드립니다.
- E-mail: clicktmd@gmail.com

※ 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "4. 수집한 개인정보의 보관 및 파기"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.




6. 개인정보의 기술적/관리적 보호 대책
회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.

1) 클릭리스는 해킹이나 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.



2) 개인정보보호전담기구를 운영합니다.
회사는 클릭리스 개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.




7. 개인정보의 파기절차 및 방법
회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 절차 및 방법은 다음과 같습니다.

가. 파기절차
내부 방침 및 기타 관련 법령에 의한 정보보호 사유 또는 보유 및 이용기간이 종료되면 파기되며, 파기되는 개인정보는 내부 정보보호 및 지침서에 정의된 절차 즉 개인정보보호책임자의 승인 및 파기 결과 확인 등의 절차로 진행됩니다.

나. 파기방법
⑴ 종이에 출력된 개인정보는 분쇄기로 분쇄를 통하여 파기합니다.
⑵ 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. 개인정보는 고유식별번호 등 특정 개인을 식별할 수 있는 정보의 집합체를 말합니다.



8. 개인정보보호책임자의 연락처
회사는 회원의 개인정보를 최선으로 보호하고 관련된 민원을 처리하기 위해 개인정보관리책임자를 지정하였습니다. 회원은 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호 책임자에게 신고할 수 있으며 책임자는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.

개인정보보호 책임자
이 름 : 김대현
소 속 : 비욘드메디슨
직 위 : 대표
신고전화 : 010-2665-1665
신고메일 : clicktmd@gmail.com


9. 기타
1) 회사의 서비스에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 회사의 본 “개인정보취급방침"이 적용되지 않음을 알려 드립니다.

2) 현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 즉시 비욘드메디슨 웹사이트 공지사항에 게시합니다.

3) 회사의 클릭리스 개인정보처리방침은 2022년 1월 19일부터 시행되었습니다.

`}</ReactMarkdown>
        </Container>
      </Page>
    </>
  );
};

export default Privacy;